import actionTypes from 'SRC/modules/redux/actionTypes'

export const setUserPackageInactiveMsg = message => ({
  type: actionTypes.SET_USER_PACKAGE_INACTIVE_MESSAGE,
  payload: message
})
